// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__5p-S9","errorLogs":"EditorFooter_errorLogs__27SOn"};